// cleanup_convert_to_typescript_file_GENERICS

import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }) => ({
  wrapper: {
    '&.row': {
      padding: [unit * 3.25, unit * 7.5, 0]
    }
  }
});

export default createUseStyles(styles);
